import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button } from "@mui/material";
import useJStyles from "$hooks/useJStyles";
import { Layout, Paper, Text } from "$components";
import { theme } from "$utils/theme/bataillog";

function Forbidden() {
  const { jclasses } = useJStyles();

  return (
    <div className={jclasses.jWrapper}>
      <Layout title="Accès interdit">
        <Paper className={jclasses.jPaper}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            style={{ gap: theme.spacing(2) }}
          >
            <NotInterestedIcon color="error" fontSize="large" />
            <Text>Vous n’êtes pas autorisé à accéder à ce contenu.</Text>
            <Button
              color="primary"
              variant="outlined"
              component={RouterLink}
              to="/projets"
            >
              Revenir à la liste des projets
            </Button>
          </Box>
        </Paper>
      </Layout>
    </div>
  );
}

export default Forbidden;
